import { render, staticRenderFns } from "./GuestInviteArea.vue?vue&type=template&id=148b0309&scoped=true&"
import script from "./GuestInviteArea.vue?vue&type=script&lang=js&"
export * from "./GuestInviteArea.vue?vue&type=script&lang=js&"
import style0 from "./GuestInviteArea.vue?vue&type=style&index=0&id=148b0309&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "148b0309",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
import { VSwitch } from 'vuetify/lib/components/VSwitch';
import { VTextField } from 'vuetify/lib/components/VTextField';
import { VTooltip } from 'vuetify/lib/components/VTooltip';
installComponents(component, {VBtn,VIcon,VRow,VSnackbar,VSwitch,VTextField,VTooltip})
